// Holds the LogRocket replay URL for the active session so API requests can
// stamp it as an X-LogRocket-URL header, letting backend logs be joined back
// to the session replay. Populated once LogRocket.getSessionURL resolves
// (which happens a beat after init), so early requests simply omit the header.

let sessionUrl = "";

export const setLogRocketSessionUrl = (url) => {
  sessionUrl = typeof url === "string" ? url : "";
};

export const getLogRocketSessionUrl = () => sessionUrl;
